import script from "./SYS49_016INS.vue?vue&type=script&setup=true&lang=js"
export * from "./SYS49_016INS.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__